import {
    AWT_NEAR_REAL_TIME,
    AWTLogManager,
    AWTEventData,
    AWTEventProperty,
    AWTEventPriority,
} from '@aria/webjs-sdk';

export function initializeLogManager(tenantTokens: string) {
    AWTLogManager.setTransmitProfile(AWT_NEAR_REAL_TIME);
    AWTLogManager.initialize(tenantTokens);
    return AWTLogManager.getSemanticContext();
}

export function getLogger(tenantToken: string) {
    return AWTLogManager.getLogger(tenantToken);
}

export function createEventProperties(eventName?: string): AWTEventData {
    return {
        name: eventName,
        properties: {},
    };
}

export function createSessionDatapoint(properties: {
    [key: string]: string | number | boolean | AWTEventProperty;
}): AWTEventData {
    let sessionEvent: AWTEventData = {
        name: 'session',
        type: 'session',
        properties,
    };
    sessionEvent.priority = AWTEventPriority.High;
    return sessionEvent;
}

export function ariaFlush() {
    AWTLogManager.flush(() => {});
}
